import { stats } from '@fiverr-private/obs';
import { PACKAGE_NAME } from '../constants';

export const metric = stats.prefix(`packages.${PACKAGE_NAME}`);
